import { render } from "./ReactionOptions.vue?vue&type=template&id=2728d1a7"
import script from "./ReactionOptions.vue?vue&type=script&lang=js"
export * from "./ReactionOptions.vue?vue&type=script&lang=js"
script.render = render

export default script